import comO1Box from "../../../engines/components/comO1Box";

const {ccclass, property} = cc._decorator;

@ccclass
export default class fpsPlayer extends cc.Component {

    // onLoad () {}

    start() {

    }

    getComO1Box() {
        return this.node.getComponent(comO1Box);
    }

    onJump() {
        this.getComO1Box().getProductLastLineVelocity().y = 1.5;
    }

    // update (dt) {}
}
